<script lang="ts">
  import Input from "../../forms/Input.svelte";
  import type { Control } from "../../forms/controls";
  import type { ControlValidator, ValidatorMessages, ValidatorResult } from "../../forms/validators";

  // either set name and validators
  export let name: string = null;
  export let placeholder: string = "";
  export let autocomplete: string = undefined;
  export let required: boolean = false;
  export let validators: ControlValidator[] = [];
  export let value: any = undefined;
  // ... or bind a control
  export let control: Control = null;
  export let standalone: boolean = false;
  export let displayName: string = undefined;
  export let errors: ValidatorMessages = undefined;

  let focus = false;
  let element: HTMLDivElement;

  function handleClear() {
    const input = element.querySelector("input");
    input.value = "";
    input.dispatchEvent(new Event("input"));
    input.focus();
  }
</script>

<div bind:this={element} class="input-search" class:input-search-active={focus}>
  <Input {name} {placeholder} {autocomplete} {required} {validators} {value} {control} {standalone} {displayName} {errors} on:focus={() => (focus = true)} on:blur={() => (focus = false)} on:change on:focus on:blur />
  <button class="input-search-button" on:focus={() => (focus = true)} on:blur={() => (focus = false)} on:click={() => handleClear()} />
</div>

<style lang="scss">
  .input-search {
    position: relative;

    :global(input) {
      border: solid 2px #ffbc00;
      padding-right: calc(56px + 0.75rem);
    }
  }

  .input-search-button {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    // aspect-ratio: 1/1; not working in iOS! so we use pixels:
    width: 56px;
    border-radius: 50%;
    background: #ffbc00 url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18.9' height='20.3' viewBox='0 0 18.9 20.3'%3E%3Cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m11.5 12.8 6 6M7.3 13.6A6.3 6.3 0 1 0 1 7.3a6.3 6.3 0 0 0 6.3 6.3Z'/%3E%3C/svg%3E") no-repeat center/50%;
    border: none;
    outline: none !important;
    transition: background ease 150ms;
  }

  .input-search-active {
    :global(input) {
      border-color: #000;
    }

    .input-search-button {
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='none' d='M0 0h24v24H0z'/%3E%3Cpath d='M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z'/%3E%3C/svg%3E") no-repeat center/50%;

      &:active {
        background-color: rgba(#000, 0.1);
      }
    }
  }
</style>
